import React, { useState, useEffect, useContext, useRef, useMemo } from "react";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import HandleHttpErrors from "../HandleHttpErrors";
import { useNavigate, useLocation } from "react-router-dom";
import { Container } from "react-bootstrap";
import { MdLiveHelp } from "react-icons/md";
import HelpModal from "../shared/HelpModal";
import HelpContext from "../shared/context/HelpProvider";
import SearchableDropdown from "../shared/SearchableDropdown";
import SearchableDropdownMulti from "../shared/SearchableDropdownMulti";
import { Row, Col, Card } from "react-bootstrap";
import JoditEditor from "jodit-react";
import MekhrazContext from "./MekhrazContaxt";

const baseURL = process.env.REACT_APP_API_JOBS;

export default function Edit(props) {
  const { visible, id, jobsList } = props;
  const { showHelp, setShowHelp, saeef, setSaeef } = useContext(HelpContext);
  const [changed, setChanged] = useState(false);
  const editor1 = useRef(null);
  const editor2 = useRef(null);
  const editor3 = useRef(null);
  const editor4 = useRef(null);
  const editor5 = useRef(null);
  const editorPrefix = useRef(null);
  const editorSuffix = useRef(null);
  const submitButton = useRef(null);
  const isSubmitting = useRef(false); // Use ref instead of state
  const navigate = useNavigate();

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Tab" && event.target.id === "reshom_plili") {
        event.preventDefault(); // Prevent the default tab behavior
        editor1.current.focus(); // Set focus on the JoditEditor component
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  const config = useMemo(
    () => ({
      readonly: false,
      height: 400,
      width: 600,
      askBeforePasteFromWord: false,
      askBeforePasteHTML: false,
      //colorPickerDefaultTab: "background",
      //buttons: ["brush"],
      toolbarAdaptive: false,
      disablePlugins: ["File", "Image", "Media"],
    }),
    []
  );

  const [departments, setDepartments] = useState([]);
  const [jobs, setJobs] = useState([]);
  const [ptorReasons, setPtorRreasons] = useState([]);
  const [mkhTypeOptions, setMkhTypeOptions] = useState([]);
  const [inputField, setInputField] = useState({});
  const formValuesRef = useRef(inputField);
  const [jobValue, setJobValue] = useState("בחר תפקיד....");
  const [kfifootValue, setKfifootValue] = useState("בחר כפיפות....");
  const { mekhrazUpdated, setMekhrazUpdated } = useContext(MekhrazContext);
  const axiosPrivate = useAxiosPrivate("application/json");

  const location = useLocation();
  //const navigateto = useNavigate(); // Hook to programmatically navigate

  // handle change event

  const handleCheckBoxChange = (e) => {
    const { name, checked } = e.target;
    setChanged(true);
    setInputField((prevState) => ({
      ...prevState,
      [name]: checked,
    }));
  };
  const handleChange = (e) => {
    e.preventDefault();
    const { name, value, type, checked } = e.target;

    if (name == "mkh_type") {
      if (value != "פטור") {
        setInputField((prevState) => ({
          ...prevState,
          ptor_reason: null,
        }));
      }
    }
    setInputField((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    setChanged(true);
  };

  const handleDDSChange = (e) => {
    e.preventDefault();
    setChanged(true);
    const { name, value } = e.target;

    let n = Number(value);
    if (value == "") {
      n = null;
    }

    setInputField((prevState) => ({
      ...prevState,
      [name]: n,
    }));
  };

  const handleChangeSDD = (id, val) => {
    setChanged(true);
    setInputField((prevState) => ({
      ...prevState,
      job: id,
    }));
  };
  /*const handleChangeJob = (id) => {
    setInputField((prevState) => ({
      ...prevState,
      job: id,
    }));
  };*/

  const handleChangeKfifoot = (id) => {
    setChanged(true);
    setInputField((prevState) => ({
      ...prevState,
      kfifoot: id,
    }));
  };

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();
    const getDepartments = async () => {
      try {
        const response = await axiosPrivate.get(baseURL + "department/", {
          signal: controller.signal,
        });
        isMounted && setDepartments(response.data);
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          if (err.response.status === 401) {
            navigate("/login", { state: { from: location }, replace: true });
          } else if (err.response.status === 403) {
            alert(HandleHttpErrors(err.response.status));
          }
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else");
        }
      }
    };
    const getMkhTypes = async () => {
      try {
        const response = await axiosPrivate.get(baseURL + "mkhtype/", {
          signal: controller.signal,
        });
        isMounted && setMkhTypeOptions(response.data[0].mkhtypeOptions);
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          if (err.response.status === 401) {
            navigate("/login", { state: { from: location }, replace: true });
          } else if (err.response.status === 403) {
            alert(HandleHttpErrors(err.response.status));
          }
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else");
        }
      }
    };
    const getPtorReasons = async () => {
      try {
        const response = await axiosPrivate.get(baseURL + "ptorreason/", {
          signal: controller.signal,
        });
        isMounted && setPtorRreasons(response.data);
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          if (err.response.status === 401) {
            navigate("/login", { state: { from: location }, replace: true });
          } else if (err.response.status === 403) {
            alert(HandleHttpErrors(err.response.status));
          }
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else");
        }
      }
    };
    const getJobs = async () => {
      try {
        const response = await axiosPrivate.get(baseURL + "jobslist/", {
          signal: controller.signal,
        });
        isMounted && setJobs(response.data);
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          if (err.response.status === 401) {
            navigate("/login", { state: { from: location }, replace: true });
          } else if (err.response.status === 403) {
            alert(HandleHttpErrors(err.response.status));
          }
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else");
        }
      }
    };

    getDepartments();
    getJobs();
    getPtorReasons();
    getMkhTypes();
    return () => {
      isMounted = false;
      isMounted && controller.abort();
    };
  }, []);

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();
    const getData = async () => {
      try {
        const response = await axiosPrivate.get(baseURL + "mekhraz/" + id, {
          signal: controller.signal,
        });
        if (isMounted) {
          setInputField(response.data);
          setKfifootValue(response.data?.kfifoot_title);
          setJobValue(response.data?.job_title);
        }
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          if (err.response.status === 401) {
            navigate("/login", { state: { from: location }, replace: true });
          } else if (err.response.status === 403) {
            alert(HandleHttpErrors(err.response.status));
          }
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else");
        }
      }
    };

    getData();
  }, [mekhrazUpdated]);

  const handleSubmit = async (e) => {
    if (e && e.preventDefault) {
      e.preventDefault(); // Prevent form from submitting when called by submit event
    }
    isSubmitting.current = true;
    setChanged(false);
    let isMounted = true;
    const controller = new AbortController();
    const saveData = async () => {
      try {
        const response = await axiosPrivate.put(
          baseURL + "mekhraz/" + id + "/",
          formValuesRef.current,
          {
            signal: controller.signal,
          }
        );

        isMounted && setMekhrazUpdated((prevState) => !prevState);
        alert("השמירה בוצעה בהצלחה");
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          if (err.response.status === 401) {
            navigate("/login", { state: { from: location }, replace: true });
          } else if (err.response.status === 403) {
            alert(HandleHttpErrors(err.response.status));
          }
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else");
        }
      }
    };
    if (inputField.ptor_reason == null && inputField.mkh_type == "פטור") {
      alert("במקרה שסוג המכרז הוא פטור, אתה חייב להזין סיבת הפטור.");
    } else {
      saveData();
      setChanged(false);
      isSubmitting.current = false;
    }
    return () => {
      isMounted = false;
      isMounted && controller.abort();
    };
  };

  useEffect(() => {
    return () => {
      if (changed && !isSubmitting.current) {
        const confirmLeave = window.confirm(
          "ערכת שינויים, האם ברצונך לשמור אותם?"
        );
        if (confirmLeave) {
          // If the user cancels, prevent navigation
          //throw new Error("Navigation cancelled");
          handleSubmit();
        }
      }
    };
  }, [changed]);

  useEffect(() => {
    formValuesRef.current = inputField;
  }, [inputField]);
  // render

  if (!visible) return;
  return (
    <Container
      style={{
        height: "calc(100vh - 40px)",
        overflowY: "scroll",
      }}
    >
      <HelpModal />
      <Card className="success container px-5 " bg="light">
        <Card.Header className="mx-auto">
          <center>
            <h3>עריכת פרטי המכרז</h3>
          </center>
        </Card.Header>
        <Card.Body>
          <form
            onSubmit={(event) => {
              setChanged(false);
              handleSubmit(event);
            }}
          >
            <Container className="col-sm-10">
              <Row>
                <Col>
                  <div className="form-group">
                    <label htmlFor="canceled">האם המכרז בוטל?</label>
                    <br />
                    <input
                      type="checkbox"
                      id="canceled"
                      name="canceled"
                      checked={inputField?.canceled}
                      onChange={handleCheckBoxChange}
                    />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <div className="form-group col-sm-6">
                    <label htmlFor="mkh_num">מספר המכרז:</label>
                    <input
                      type="text"
                      name="mkh_num"
                      defaultValue={inputField?.mkh_num}
                      onChange={handleChange}
                      className="form-control"
                      id="mkh_num"
                      placeholder="כמו 01/2022"
                      required
                    />
                  </div>
                </Col>
                <Col>
                  <div className="form-group">
                    <label htmlFor="title">תאור:</label>
                    <input
                      type="text"
                      name="title"
                      defaultValue={inputField?.title}
                      onChange={handleChange}
                      className="form-control"
                      id="title"
                      placeholder="הקלד תאור למכרז"
                      required
                    />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <div className="form-group">
                    <label htmlFor="department">מחלקה:</label>
                    <br />
                    <select
                      name="department"
                      onChange={handleDDSChange}
                      value={inputField?.department}
                      required
                    >
                      <option value="" selected>
                        בחר מחלקה
                      </option>
                      {departments?.map((d) => (
                        <option key={d.id} value={d.id}>
                          {d.title}
                        </option>
                      ))}
                    </select>
                  </div>
                </Col>
                <Col>
                  <div className="form-group">
                    <label htmlFor="yeood_mesra">ייעוד משרה:</label>
                    <input
                      type="text"
                      name="yeood_mesra"
                      value={inputField?.yeood_mesra}
                      onChange={handleChange}
                      className="form-control"
                      id="yeood_mesra"
                      placeholder="הקלד ייעוד משרה"
                    />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <div className="form-group">
                    <label htmlFor="job">תפקיד:</label>
                    <br />

                    <SearchableDropdownMulti
                      options={jobs}
                      label="jobtype_title"
                      label2="title"
                      label3="ignore"
                      id="id"
                      other="title "
                      selectedVal={jobValue}
                      handleChange={(val, id) => {
                        setChanged(true);
                        setJobValue(val);
                        //setUserEmail(email);
                        handleChangeSDD(id, val);
                      }}
                      inputProps={{ autocomplete: "off" }}
                    />
                  </div>
                </Col>
                <Col>
                  <div className="form-group">
                    <label htmlFor="kfifoot">כפיפות ל:</label>
                    <br />
                    <SearchableDropdown
                      options={jobs}
                      label="title"
                      id="id"
                      other="title"
                      selectedVal={kfifootValue}
                      handleChange={(val, id) => {
                        setChanged(true);
                        setKfifootValue(val);
                        handleChangeKfifoot(id);
                      }}
                      inputProps={{ autocomplete: "off" }}
                    />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <div className="form-group">
                    <label>סוג:</label>
                    <br />
                    <select
                      name="mkh_type"
                      onChange={handleChange}
                      value={inputField?.mkh_type}
                      required
                    >
                      <option key="0" value="" selected>
                        בחר סוג
                      </option>
                      {mkhTypeOptions?.map((a) => (
                        <option key={a[0]} value={a[1]}>
                          {a[1]}
                        </option>
                      ))}
                    </select>
                  </div>
                </Col>
                <Col>
                  <div className="form-group">
                    <label htmlFor="ptor_reason">סיבת הפטור:</label>
                    <br />
                    <select
                      name="ptor_reason"
                      onChange={handleDDSChange}
                      value={inputField?.ptor_reason || ""}
                    >
                      <option value="" selected>
                        אין פטור
                      </option>
                      {ptorReasons?.map((p) => (
                        <option key={p.id} value={p.id}>
                          {p.title}
                        </option>
                      ))}
                    </select>
                  </div>
                </Col>
              </Row>

              <Row>
                <Col>
                  <div className="form-group">
                    <label htmlFor="mesrot_num">מספר המשרות המוצעות:</label>
                    <input
                      type="number"
                      name="mesrot_num"
                      defaultValue={inputField?.mesrot_num}
                      onChange={handleChange}
                      className="form-control"
                      id="mesrot_num"
                      placeholder="מספר המשרות המוצעות"
                      required
                    />
                  </div>
                </Col>
                <Col>
                  <div className="form-group">
                    <label htmlFor="ahoz_mesra">אחוז כל משרה בממוצע:</label>
                    <input
                      type="number"
                      name="ahoz_mesra"
                      defaultValue={inputField?.ahoz_mesra}
                      onChange={handleChange}
                      className="form-control"
                      id="ahoz_mesra"
                      placeholder="50"
                      required
                    />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <div className="form-group">
                    <label htmlFor="persom_date">תאריך פרסום:</label>
                    <input
                      type="date"
                      name="persom_date"
                      value={inputField?.persom_date}
                      onChange={handleChange}
                      className="form-control"
                      id="persom_date"
                      placeholder="תאריך הפרסום בעיתונות"
                      required
                    />
                  </div>
                </Col>
                <Col>
                  <div className="form-group">
                    <label
                      onClick={() => {
                        setSaeef("5");
                        setShowHelp(true);
                      }}
                    >
                      תאריך הגשה אחרון:
                      <span className="help">
                        <MdLiveHelp />
                      </span>
                    </label>
                    <input
                      type="date"
                      name="hagsha_date"
                      value={inputField?.hagsha_date}
                      onChange={handleChange}
                      className="form-control"
                      id="hagsha_date"
                      placeholder="30-11-2022"
                      required
                      readOnly
                    />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <div className="form-group">
                    <label htmlFor="dirog">דירוג:</label>
                    <input
                      type="text"
                      name="dirog"
                      defaultValue={inputField?.dirog}
                      onChange={handleChange}
                      className="form-control"
                      id="dirog"
                      placeholder="כמו: מחר 39-41"
                      required
                    />
                  </div>
                </Col>

                <Col>
                  <div className="form-group">
                    <label htmlFor="reshom_plili">
                      תצהיר בדבר היעדר הרשעות פליליות?
                    </label>
                    <br />
                    <input
                      type="checkbox"
                      id="reshom_plili"
                      name="reshom_plili"
                      checked={inputField?.reshom_plili}
                      onChange={handleCheckBoxChange}
                    />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col className="d-flex justify-content-center">
                  <div className="mb-2">
                    <label htmlFor="prefix">
                      {" "}
                      רישא-תופיע אחרי שם ומספר המכרז-
                    </label>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col className="d-flex justify-content-center">
                  <JoditEditor
                    editorRef={editorPrefix}
                    name="prefix"
                    className="form-control"
                    tabIndex={17}
                    value={inputField?.prefix || ""}
                    config={config}
                    onBlur={(newContent) => {
                      setInputField((prevState) => ({
                        ...prevState,
                        prefix: newContent,
                      }));
                    }}
                    onChange={(newContent) => {
                      if (inputField.prefix !== newContent) {
                        setChanged(true);
                      }
                    }}
                  />
                </Col>
              </Row>
              <Row>
                <Col className="d-flex justify-content-center">
                  <div className="mb-2">
                    <label htmlFor="ekary_tafkid"> עיקרי התפקיד </label>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col className="d-flex justify-content-center">
                  <JoditEditor
                    editorRef={editor1}
                    name="ekary_tafkid"
                    className="form-control"
                    tabIndex={17}
                    value={inputField?.ekary_tafkid || ""}
                    config={config}
                    onBlur={(newContent) => {
                      setInputField((prevState) => ({
                        ...prevState,
                        ekary_tafkid: newContent,
                      }));
                    }}
                    onChange={(newContent) => {
                      if (inputField.ekary_tafkid !== newContent) {
                        setChanged(true);
                      }
                    }}
                  />
                </Col>
              </Row>
              <Row>
                <Col className="d-flex justify-content-center">
                  <div className="mb-2">
                    <label htmlFor="haskala">דרישות השכלה </label>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col className="d-flex justify-content-center">
                  <JoditEditor
                    editorRef={editor2}
                    tabIndex={18}
                    name="haskala"
                    value={inputField?.haskala || ""}
                    config={config}
                    onBlur={(newContent) => {
                      setInputField((prevState) => ({
                        ...prevState,
                        haskala: newContent,
                      }));
                    }}
                    onChange={(newContent) => {
                      if (inputField.haskala !== newContent) {
                        setChanged(true);
                      }
                    }}
                  />
                </Col>
              </Row>
              <Row>
                <Col className="d-flex justify-content-center">
                  <div className="mb-2">
                    <label htmlFor="nesion_mektsoey">
                      דרישות נסיון מקצועי{" "}
                    </label>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col className="d-flex justify-content-center">
                  <JoditEditor
                    editorRef={editor3}
                    tabIndex={19}
                    name="nesion_mektsoey"
                    value={inputField?.nesion_mektsoey || ""}
                    config={config}
                    onBlur={(newContent) => {
                      setInputField((prevState) => ({
                        ...prevState,
                        nesion_mektsoey: newContent,
                      }));
                    }}
                    onChange={(newContent) => {
                      if (inputField.nesion_mektsoey !== newContent) {
                        setChanged(true);
                      }
                    }}
                  />
                </Col>
              </Row>
              <Row>
                <Col className="d-flex justify-content-center">
                  <div className="mb-2">
                    <label htmlFor="nesion_neholy">דרישות נסיון ניהולי </label>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col className="d-flex justify-content-center">
                  <JoditEditor
                    editorRef={editor4}
                    tabIndex={20}
                    name="nesion_neholy"
                    value={inputField?.nesion_neholy || ""}
                    config={config}
                    onBlur={(newContent) => {
                      setInputField((prevState) => ({
                        ...prevState,
                        nesion_neholy: newContent,
                      }));
                    }}
                    onChange={(newContent) => {
                      if (inputField.nesion_neholy !== newContent) {
                        setChanged(true);
                      }
                    }}
                  />
                </Col>
              </Row>
              <Row>
                <Col className="d-flex justify-content-center">
                  <div className="mb-2">
                    <label htmlFor="drishot_nosafot">דרישות נוספות</label>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col className="d-flex justify-content-center">
                  <JoditEditor
                    editorRef={editor5}
                    tabIndex={21}
                    name="drishot_nosafot"
                    value={inputField?.drishot_nosafot || ""}
                    config={config}
                    onBlur={(newContent) => {
                      setInputField((prevState) => ({
                        ...prevState,
                        drishot_nosafot: newContent,
                      }));
                    }}
                    onChange={(newContent) => {
                      if (inputField.drishot_nosafot !== newContent) {
                        setChanged(true);
                      }
                    }}
                  />
                </Col>
              </Row>
              <Row>
                <Col className="d-flex justify-content-center">
                  <div className="mb-2">
                    <label htmlFor="suffix">
                      {" "}
                      סיפא-תופיע לפני הצגת שם החתום על המכרז-
                    </label>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col className="d-flex justify-content-center">
                  <JoditEditor
                    editorRef={editorSuffix}
                    tabIndex={22}
                    name="suffix"
                    value={inputField?.suffix || ""}
                    config={config}
                    onBlur={(newContent) => {
                      setInputField((prevState) => ({
                        ...prevState,
                        suffix: newContent,
                      }));
                    }}
                    onChange={(newContent) => {
                      if (inputField?.suffix !== newContent) {
                        setChanged(true);
                      }
                    }}
                  />
                </Col>
              </Row>

              <br></br>
              <div className="d-flex justify-content-center">
                <button
                  type="submit"
                  ref={submitButton}
                  tabIndex={23}
                  className="btn btn-primary"
                  onClick={() => {
                    isSubmitting.current = true;
                    setChanged(false);
                  }}
                >
                  שמור
                </button>
              </div>
            </Container>
          </form>
        </Card.Body>
      </Card>
    </Container>
  );
}
